// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ju3w","right":"Footer_right__22D46","buttons":"Footer_buttons__31caW"};